// extracted by mini-css-extract-plugin
export default {"wrapper":"main-04_wrapper__vrBtL","container":"main-04_container__D7rXZ","boxTag":"main-04_boxTag__A3ady","tag":"main-04_tag__xmhjp"};